/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWarehouseInventoryProductDto } from '../models/CreateWarehouseInventoryProductDto';
import type { InventoryBlockHistoryResponseDto } from '../models/InventoryBlockHistoryResponseDto';
import type { UpdateAvailabilityStatusDto } from '../models/UpdateAvailabilityStatusDto';
import type { UpdateWarehouseInventoryProductDto } from '../models/UpdateWarehouseInventoryProductDto';
import type { WarehouseInventorySummaryDto } from '../models/WarehouseInventorySummaryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WarehouseInventoryProductsService {
  /**
   * Create a new warehouse inventory product
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerCreate(
    requestBody: CreateWarehouseInventoryProductDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/warehouse-inventory-products',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all warehouse inventory products
   * @param page Page number, default is 1
   * @param limit Items per page, default is 10
   * @param productCode Filter by product code (partial match)
   * @param status Filter by status
   * @param availabilityStatus Filter by availability status
   * @param locationId Filter by location ID
   * @param transferredToBranch Filter by transferred to branch status
   * @param productCodeUnique Filter by product code unique (partial match)
   * @param productName Filter by product name (partial match)
   * @param searchTerm Search by both product code unique and product name
   * @param categoryName Filter by product category name (partial match)
   * @param createdAtStart Filter by created date range start (ISO format)
   * @param createdAtEnd Filter by created date range end (ISO format)
   * @param recordCode Filter by inventory record code (partial match)
   * @param searchTag Search by tag name
   * @param materialId Filter by material ID
   * @param diameterSize Filtro por talla — coincidencia exacta (diameterSize)
   * @param color Filter by color (partial match)
   * @param workshopCode Filter by workshop code (partial match)
   * @param weightGramsMin Minimum weight (grams) on warehouse inventory piece
   * @param weightGramsMax Maximum weight (grams) on warehouse inventory piece
   * @param salePriceMin Minimum sale price on warehouse inventory piece
   * @param salePriceMax Maximum sale price on warehouse inventory piece
   * @param salePricePerGramMin Minimum sale price per gram (salePrice / weightGrams)
   * @param salePricePerGramMax Maximum sale price per gram (salePrice / weightGrams)
   * @param sortBy Whitelist: createdAt, recordCompletedAt, updatedAt, productCodeUnique, productName, categoryName, recordCode, status, availabilityStatus, locationName, salePrice, firstAssignedAt
   * @param sortOrder ASC or DESC (default DESC)
   * @param excludeCancelledAvailability If true, exclude pieces with availability CANCELLED (e.g. warehouse management after transfer write-offs)
   * @param warehousePlacementOnly If true, only UNASSIGNED and IN_TRANSIT placement (excludes ASSIGNED / branch stock)
   * @param assignedPlacementOnly If true, only ASSIGNED placement (branch management: excludes warehouse and in-transit)
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerFindAll(
    page?: number,
    limit?: number,
    productCode?: string,
    status?: string,
    availabilityStatus?: string,
    locationId?: number,
    transferredToBranch?: boolean,
    productCodeUnique?: string,
    productName?: string,
    searchTerm?: string,
    categoryName?: string,
    createdAtStart?: string,
    createdAtEnd?: string,
    recordCode?: string,
    searchTag?: string,
    materialId?: number,
    diameterSize?: string,
    color?: string,
    workshopCode?: string,
    weightGramsMin?: number,
    weightGramsMax?: number,
    salePriceMin?: number,
    salePriceMax?: number,
    salePricePerGramMin?: number,
    salePricePerGramMax?: number,
    sortBy?: string,
    sortOrder?: 'ASC' | 'DESC',
    excludeCancelledAvailability?: boolean,
    warehousePlacementOnly?: boolean,
    assignedPlacementOnly?: boolean,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/warehouse-inventory-products',
      query: {
        page: page,
        limit: limit,
        productCode: productCode,
        status: status,
        availabilityStatus: availabilityStatus,
        locationId: locationId,
        transferredToBranch: transferredToBranch,
        productCodeUnique: productCodeUnique,
        productName: productName,
        searchTerm: searchTerm,
        categoryName: categoryName,
        createdAtStart: createdAtStart,
        createdAtEnd: createdAtEnd,
        recordCode: recordCode,
        searchTag: searchTag,
        materialId: materialId,
        diameterSize: diameterSize,
        color: color,
        workshopCode: workshopCode,
        weightGramsMin: weightGramsMin,
        weightGramsMax: weightGramsMax,
        salePriceMin: salePriceMin,
        salePriceMax: salePriceMax,
        salePricePerGramMin: salePricePerGramMin,
        salePricePerGramMax: salePricePerGramMax,
        sortBy: sortBy,
        sortOrder: sortOrder,
        excludeCancelledAvailability: excludeCancelledAvailability,
        warehousePlacementOnly: warehousePlacementOnly,
        assignedPlacementOnly: assignedPlacementOnly,
      },
    });
  }
  /**
   * Get summary statistics for warehouse inventory products
   * @param locationId Filter by location ID
   * @param productCode Filter by product code (partial match)
   * @param status Filter by status
   * @param transferredToBranch Filter by transferred to branch status
   * @param productCodeUnique Filter by product code unique (partial match)
   * @param productName Filter by product name (partial match)
   * @param searchTerm Search by both product code unique and product name
   * @param categoryName Filter by product category name (partial match)
   * @param createdAtStart Filter by created date range start (ISO format)
   * @param createdAtEnd Filter by created date range end (ISO format)
   * @param recordCode Filter by inventory record code (partial match)
   * @param availabilityStatus Filter by availability status
   * @param searchTag Search by tag name
   * @param materialId Filter by material ID
   * @param diameterSize Filtro por talla — coincidencia exacta (diameterSize)
   * @param color Filter by color (partial match)
   * @param workshopCode Filter by workshop code (partial match)
   * @param weightGramsMin Minimum weight (grams) on warehouse inventory piece
   * @param weightGramsMax Maximum weight (grams) on warehouse inventory piece
   * @param salePriceMin Minimum sale price on warehouse inventory piece
   * @param salePriceMax Maximum sale price on warehouse inventory piece
   * @param salePricePerGramMin Minimum sale price per gram (salePrice / weightGrams)
   * @param salePricePerGramMax Maximum sale price per gram (salePrice / weightGrams)
   * @param excludeCancelledAvailability If true, exclude pieces with availability CANCELLED from summary (warehouse KPIs)
   * @param warehousePlacementOnly If true, only UNASSIGNED and IN_TRANSIT in summary (warehouse management)
   * @param assignedPlacementOnly If true, only ASSIGNED in summary (branch management)
   * @returns WarehouseInventorySummaryDto Summary statistics for warehouse inventory products
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerGetSummary(
    locationId?: number,
    productCode?: string,
    status?: string,
    transferredToBranch?: boolean,
    productCodeUnique?: string,
    productName?: string,
    searchTerm?: string,
    categoryName?: string,
    createdAtStart?: string,
    createdAtEnd?: string,
    recordCode?: string,
    availabilityStatus?: string,
    searchTag?: string,
    materialId?: number,
    diameterSize?: string,
    color?: string,
    workshopCode?: string,
    weightGramsMin?: number,
    weightGramsMax?: number,
    salePriceMin?: number,
    salePriceMax?: number,
    salePricePerGramMin?: number,
    salePricePerGramMax?: number,
    excludeCancelledAvailability?: boolean,
    warehousePlacementOnly?: boolean,
    assignedPlacementOnly?: boolean,
  ): CancelablePromise<WarehouseInventorySummaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/warehouse-inventory-products/summary',
      query: {
        locationId: locationId,
        productCode: productCode,
        status: status,
        transferredToBranch: transferredToBranch,
        productCodeUnique: productCodeUnique,
        productName: productName,
        searchTerm: searchTerm,
        categoryName: categoryName,
        createdAtStart: createdAtStart,
        createdAtEnd: createdAtEnd,
        recordCode: recordCode,
        availabilityStatus: availabilityStatus,
        searchTag: searchTag,
        materialId: materialId,
        diameterSize: diameterSize,
        color: color,
        workshopCode: workshopCode,
        weightGramsMin: weightGramsMin,
        weightGramsMax: weightGramsMax,
        salePriceMin: salePriceMin,
        salePriceMax: salePriceMax,
        salePricePerGramMin: salePricePerGramMin,
        salePricePerGramMax: salePricePerGramMax,
        excludeCancelledAvailability: excludeCancelledAvailability,
        warehousePlacementOnly: warehousePlacementOnly,
        assignedPlacementOnly: assignedPlacementOnly,
      },
    });
  }
  /**
   * Get warehouse inventory status metrics
   * @param locationId Optional location filter
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerGetInventoryStatusMetrics(
    locationId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/warehouse-inventory-products/metrics/status',
      query: {
        locationId: locationId,
      },
    });
  }
  /**
   * Get block, unblock, and write-off history for a warehouse inventory product
   * @param id Warehouse inventory product ID
   * @returns InventoryBlockHistoryResponseDto Block and write-off history retrieved successfully
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerGetBlockHistory(
    id: number,
  ): CancelablePromise<InventoryBlockHistoryResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/warehouse-inventory-products/{id}/block-history',
      path: {
        id: id,
      },
    });
  }
  /**
   * Get a specific warehouse inventory product
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/warehouse-inventory-products/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Update a warehouse inventory product
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerUpdate(
    id: string,
    requestBody: UpdateWarehouseInventoryProductDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/warehouse-inventory-products/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete a warehouse inventory product
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/warehouse-inventory-products/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Synchronize attributes from product catalog to a specific warehouse inventory product
   * @param id The warehouse inventory product ID
   * @param overwrite Whether to overwrite existing custom values
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerSyncAttributes(
    id: string,
    overwrite?: boolean,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/warehouse-inventory-products/{id}/sync-attributes',
      path: {
        id: id,
      },
      query: {
        overwrite: overwrite,
      },
    });
  }
  /**
   * Bulk synchronize attributes from product catalog to warehouse inventory products
   * @param productId Filter by product ID
   * @param overwrite Whether to overwrite existing custom values
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerBulkSyncAttributes(
    productId?: number,
    overwrite?: boolean,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/warehouse-inventory-products/bulk-sync-attributes',
      query: {
        productId: productId,
        overwrite: overwrite,
      },
    });
  }
  /**
   * Update warehouse inventory product availability status
   * @param id Warehouse inventory product ID
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerUpdateAvailabilityStatus(
    id: number,
    requestBody: UpdateAvailabilityStatusDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/warehouse-inventory-products/{id}/availability-status',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Bulk update warehouse inventory products availability status
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static warehouseInventoryProductsControllerBulkUpdateAvailabilityStatus(requestBody: {
    /**
     * Array of warehouse inventory product IDs
     */
    ids?: Array<number>;
    /**
     * New availability status
     */
    status?: 'AVAILABLE' | 'SOLD' | 'RESERVED' | 'PARTIAL_PAYMENT';
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/warehouse-inventory-products/bulk-update-availability-status',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
